<script lang="ts" setup>
import { ElRadio, ElRadioButton, ElRadioGroup } from "element-plus";
import { computed, inject, onMounted, ref, watch } from "vue";
import { DICT_STORE, excludeObjectKeys } from "../../../utils";
import { excludeRadioKeys, RadioEmits, RadioProps } from "./radio";

defineOptions({
  name: "IRadio",
});
const props = defineProps(RadioProps);
const emit = defineEmits(RadioEmits);
const dictStore = inject(DICT_STORE);
const bindAttrs = computed(() => excludeObjectKeys(props, excludeRadioKeys));

const radioOptions = ref<any[]>([]);
onMounted(() => setOptions());
watch(
  () => props.data,
  () => setOptions(),
  { deep: true },
);
async function setOptions() {
  const list = await getList();
  radioOptions.value = props.dataCallback ? props.dataCallback(list) : list;
}

async function getList() {
  if (Array.isArray(props.data)) {
    return props.data;
  }
  if (dictStore) {
    return await dictStore.getDict(props.data);
  }
  return [];
}

const value = ref("");
watch(
  () => props.modelValue,
  (val: any) => (value.value = val),
  { deep: true, immediate: true },
);
const handleChange = (val: any) => {
  emit("change", val);
  emit("update:modelValue", val);
};
</script>

<template>
  <ElRadioGroup v-model="value" v-bind="bindAttrs" @change="handleChange">
    <template v-if="type === 'button'">
      <ElRadioButton
        v-for="item of radioOptions"
        :key="item[optValue]"
        :label="item[optValue]"
        :disabled="item.disabled"
      >
        {{ item[optLabel] }}
      </ElRadioButton>
    </template>
    <template v-else>
      <ElRadio
        v-for="item of radioOptions"
        :key="item[optValue]"
        :label="item[optValue]"
        :disabled="item.disabled"
      >
        {{ item[optLabel] }}
      </ElRadio>
    </template>
  </ElRadioGroup>
</template>
